<template>
  <vx-card no-shadow>

    <div class="flex flex-wrap justify-between items-center mb-8">
       <vs-row class="mt-3">
        <vs-col vs-type="flex" vs-justify="start" vs-align="start" vs-w="12">
          <h3>Configuración de imprimibles</h3>
        </vs-col>
      </vs-row>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h5>
            <feather-icon icon="CheckCircleIcon" class="w-6 h-6 mr-3 "></feather-icon>
            Logo
          </h5>
        </vs-col>
      </vs-row>
      <vs-row class="mt-6" v-if="edit1">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-input icon-after="true" class="w-1/2"  icon="insert_photo" type="file" accept="image/*" 
              @change="previewImage"
            />
        </vs-col>
      </vs-row>      
      <vs-row class="mt-6" v-if="edit1">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <p>Progreso: {{uploadValue.toFixed()+"%"}}</p>
        </vs-col>
      </vs-row>
      <vs-row class="mt-6" v-if="picture">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <img :src="picture" alt="preview" style="max-widht: 150px; max-height: 150px;">
        </vs-col>
      </vs-row>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">

            <vs-button v-if="edit1" color="primary" type="filled" icon="save" @click="onUpload">Guardar</vs-button>
            <vs-button v-if="edit1 && cancel1" color="warning" type="filled" class="ml-2" icon="undo" @click="edit1 = !edit1; cancel1 = !cancel1">Cancelar</vs-button>
            <vs-button v-if="!edit1" color="warning" type="filled" icon="edit" @click="edit1 = !edit1; cancel1 = !cancel1">Editar</vs-button>

        </vs-col>
      </vs-row>
      
      <vs-divider></vs-divider>
      <!-- FIRMA -->
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <h5>
            <code class="ml-2">F</code>
            Firma
          </h5>
        </vs-col>
      </vs-row>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <p>Genera tu firma en
            <code> 
              <a href="https://createmysignature.com/" target="_blank"> 
                CreateMySignature.com
              </a>
            </code>
          </p>
        </vs-col>
      </vs-row>
      <!--  -->
      <vs-row class="mt-6" v-if="edit2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-input icon-after="true" class="w-1/2"  icon="insert_photo" type="file" accept="image/*" 
              @change="previewImage2"
            />
        </vs-col>
      </vs-row>      
      <vs-row class="mt-6" v-if="edit2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <p>Progreso: {{uploadValue2.toFixed()+"%"}}</p>
        </vs-col>
      </vs-row>
      <vs-row class="mt-6" v-if="picture2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <img :src="picture2" alt="preview" style="max-widht: 150px; max-height: 150px;">
        </vs-col>
      </vs-row>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">

            <vs-button v-if="edit2" color="primary" type="filled" icon="save" @click="onUpload2">Guardar</vs-button>
            <vs-button v-if="edit2 && cancel2" color="warning" type="filled" icon="undo" class="ml-2" @click="edit2 = !edit2; cancel2 =  !cancel2">Cancelar</vs-button>
            <vs-button v-if="!edit2" color="warning" type="filled" icon="edit" @click="edit2 = !edit2; cancel2 = !cancel2">Editar</vs-button>

        </vs-col>
      </vs-row>
     
    </div>
      
  </vx-card>
</template>

<script>
import firebase from 'firebase/app' // 
import 'firebase/storage';  // 


export default {
  data () {
    return {
      edit1: false,
      edit2: false,
      cancel1: false,
      cancel2: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      imageData2: null,
      picture2: null,
      uploadValue2: 0,
      userData: {},
      evolugyUser: {},
      invalid: true,
      existing: false,
      zoomJWT: null,
      zoomEmail: null,
      zoomURL: 'https://zoom.us/oauth/authorize?response_type=code&client_id=BOg4tcdKTFnPz9O1cHoA&redirect_uri=https://app.evolugy.com/auth/zoom-redirect',
      old_password: '',
      new_password: '',
      confirm_new_password: ''
    }
  },
  computed: {
    // activeUserInfo () {
    //   return this.$store.state.AppActiveUser
    // }
    findZoomClinicsActive(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
      });
      console.log(zoomClinics);
      return zoomClinics
    },
  },
  beforeCreate(){
     this.$store.dispatch('fetchClinics').then(response=>{
      // console.log('clinics: ', response);
    }, error => {
      console.error(error);
    });

  },
  created (){
    console.log('USER: ',this.$store.state.AppActiveUser);

    console.log('zoomC: ', this.findZoomClinicsActive);

    this.userData = JSON.parse(JSON.stringify(this.$store.state.AppActiveUser))
    if(this.userData.meta.zoom_jwt){
      this.zoomJWT = this.userData.meta.zoom_jwt;
      this.zoomEmail = this.userData.meta.zoom_email;
      this.existing = true;
    } else {
      this.existing = false;
    }

    this.picture = this.userData.meta.logo_url ?  this.userData.meta.logo_url : null;
    this.edit1 = this.userData.meta.logo_url ? false : true;
    this.picture2 = this.userData.meta.signature_url ?  this.userData.meta.signature_url : null;
    this.edit2 = this.userData.meta.signature_url ? false : true;

    this.evolugyUser = JSON.parse(window.localStorage.getItem('userInfo'));
  },
  methods: {
    
    previewImage(event, img) {
      this.uploadValue=0;
      this.picture=null;
      this.imageData = event.target.files[0];
    },
    previewImage2(event, img) {
      this.uploadValue2=0;
      this.picture2=null;
      this.imageData2 = event.target.files[0];
    },
    onUpload(){
      this.picture=null;
      const storageRef = firebase.storage().ref(`${Math.random().toString(36).substring(7)+'_'+this.imageData.name}`).put(this.imageData);
      storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{
        this.uploadValue=100;
        storageRef.snapshot.ref.getDownloadURL().then((url)=>{
          this.picture =url;
          const metaUpdateUser = {
              id: this.userData.id,
              meta: {...this.userData.meta, ...{'logo_url': url}, ...{'signature_url': this.picture2} }
            };
            this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
            this.showAlert(
            "success",
            "Logo Agregado",
            "Logo Agregado Agregado éxitosamente!"
            );
            this.edit1 = false;
        });
      }
      );
    },
    onUpload2(){
      this.picture2=null;
      const storageRef = firebase.storage().ref(`${Math.random().toString(36).substring(7)+'_'+this.imageData2.name}`).put(this.imageData2);
      storageRef.on(`state_changed`,snapshot=>{
        this.uploadValue2 = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
      }, error=>{console.log(error.message)},
      ()=>{

          this.uploadValue2=100;
          storageRef.snapshot.ref.getDownloadURL().then((url)=>{
            this.picture2 = url;
            const metaUpdateUser = {
              id: this.userData.id,
              meta: {...this.userData.meta, ...{'signature_url': url}, ...{'logo_url': this.picture}}
            };
            this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
            this.showAlert(
            "success",
            "Firma Agregada",
            "Firma Agregada Agregado éxitosamente!"
            );
            this.edit2 = false;
          }
        );
      }
      );
    },
    goZM(url){
      var goURL = "";
      switch (url) {
        case 1:
          goURL = "https://zoom.us/signin"    
          break;
        case 2:
          goURL = "https://marketplace.zoom.us/develop/create"    
          break; 
      
        default:
          goURL = "https://zoom.us/signin" 
          break;
      }
      window.open(goURL, '_blank');
    },
    addZoom(){
      const metaUpdateUser = {
        id: this.userData.id,
        meta: {...this.userData.meta, ...{'zoom_jwt': this.zoomJWT, 'zoom_email': this.zoomEmail}}
      };
      this.$store.dispatch('evolugy/updateUser', metaUpdateUser);
      
      if(this.findZoomClinicsActive.length == 0){
        this.addNewClinic();
      }  else {
        console.log('already has zoom.')
      }
      
      this.showAlert(
            "success",
            "Acceso de Zoom Agregado",
            "Acceso de Zoom Agregado éxitosamente!"
          );
      this.existing = true;
    },
    addNewClinic(){
      
      let newClinicObj = new Object();
      newClinicObj.address = 'Zoom.us',
      newClinicObj.address_2 = 'Clinica Virtual',
      newClinicObj.phone = this.userData.phone ? this.userData.phone : [],
      // newClinicObj.city = this.newClinic.city,
      // newClinicObj.zone = this.newClinic.zone,
      // newClinicObj.country = this.newClinic.country.name,
      newClinicObj.title = 'Clinica Virtual',
      // newClinicObj.notes = this.newClinic.notes,
      newClinicObj.meta = {"type": "Virtual" , "zoom_active":"false"};

      this.$store.dispatch('addClinic',newClinicObj).then(response => {
            console.log(response);
            this.showAlert('success','Clinica Agregada','Clinica Agregada éxitosamente!');
        }, error => {
            console.error(error);
            this.showAlert('danger','Error al agregar clinica',error.response.data.error);
        });
      
    },
    showAlert(color, title, text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
  },
  watch: {
    zoomJWT (oldV, newV){
      console.log(oldV,newV);
      if(this.zoomJWT.length >=168){
        this.invalid = false;
      }
    }
  }
}
</script>
